// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export default {
    "dirty": false,
    "raw": "400360c",
    "hash": "400360c",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "400360c",
    "semverString": null
};
/* tslint:enable */
